(() => {
  'use strict';

  const menus = {
    bovino: {
      title: 'Weasy Food Adultos — Bovina',
      ingredients:
        'Coração e língua de bovino (47%), batata-doce, arroz, água, fígado de bovino (5%), abobrinha, banha suína, alecrim desidratado, cloreto de sódio, óleo de girassol, extrato de alecrim, extrato de chá verde e concentrado de tocoferóis.\n\nEventuais substitutivos: carne de bovino, abóbora, chuchu.'
    },
    frango: {
      title: 'Weasy Food Adultos — Frango',
      ingredients:
        'Moela de frango (50%), arroz, água, cenoura, abóbora, fígado de frango (5%), banha suína, cloreto de sódio, cúrcuma, óleo de girassol, extrato de alecrim, extrato de chá verde e concentrado de tocoferóis.\n\nEventuais substitutivos: peito de frango, beterraba, batata-doce.'
    },
    suino: {
      title: 'Weasy Food Adultos — Suína',
      ingredients:
        'Coração de suíno (48,5%), arroz, batata-doce, abóbora, fígado de suíno (7%), abobrinha, água, cloreto de sódio, banha suína, manjericão desidratado, óleo de girassol, extrato de alecrim, extrato de chá verde e concentrado de tocoferóis.'
    }
  };

  function bindMenuIngredients(root) {
    const modal = root.querySelector('[data-menu-ingredients-modal]');
    if (!modal || modal.dataset.bound) return;
    modal.dataset.bound = 'true';

    const title = modal.querySelector('#menu-ingredients-title');
    const text = modal.querySelector('[data-menu-ingredients-text]');
    const close = () => modal.close();

    root.querySelectorAll('[data-menu-ingredients]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const menu = menus[trigger.dataset.menuIngredients];
        if (!menu) return;

        title.textContent = menu.title;
        text.textContent = menu.ingredients;
        modal.showModal();
      });
    });

    modal.querySelector('[data-menu-ingredients-close]').addEventListener('click', close);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) close();
    });
  }

  function init(root) {
    if (!root || root.dataset.checkoutBound) return;
    root.dataset.checkoutBound = 'true';

    bindMenuIngredients(root);

    const form = root.querySelector('#wf-kit-form');
    if (!form) return;

    // A seção atual usa um link nativo: funciona mesmo sem este arquivo.
    if (form.querySelector('[data-direct-checkout]')) return;

    const submit = form.querySelector('.kit-submit');
    const kit = form.querySelector('input[name="id"][data-fixed-kit]:not(:disabled)');

    if (!kit) {
      if (submit) submit.disabled = true;
      return;
    }

    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (window.location.protocol === 'file:') return;

        const destination = new URL(
          `/cart/${encodeURIComponent(kit.value)}:1`,
          window.location.origin
        );
        window.location.assign(destination.href);
      },
      true
    );
  }

  document.querySelectorAll('[data-wf-shopify]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-wf-shopify]').forEach(init);
  });
})();
